var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteSearchInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B4C3D0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    className: "st0",
    d: "M8.9,15.4c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S12.5,15.4,8.9,15.4L8.9,15.4z  M18,15.7l-1.5-0.1l-0.2-1.9c2.2-3.4,1.8-8.1-1.2-11.1C11.6-0.9,6-0.9,2.6,2.6c-3.5,3.5-3.5,9.1,0,12.6c3,3,7.7,3.4,11.1,1.2l2,0.1 V18l5.2,6h1.5l1.5-1.5V21L18,15.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSearchInactive);
export default __webpack_public_path__ + "static/media/invite_search_inactive.de50dda29da03152d7d74ff16241d0ab.svg";
export { ForwardRef as ReactComponent };